import { type ReactNode } from 'react';
import { Card } from '@ics-portal/guardian';
import type { Scalars } from '@gql/graphql';
import { ProjectPath, getProjectPath } from '@utils/getMenuContent';
import { useSummaryCards } from '@pages/project/summary/_utils/contexts/SummaryCardsContext';
import { SummaryCardTitle } from './components/SummaryCardTitle';
import s from './SummaryCards.module.scss';
import { SummaryCardContent } from './components/SummaryCardContent';

interface AssetsCardProps {
    pid: Scalars['ID']['input'];
}

export default function AssetsCard({ pid }: AssetsCardProps): ReactNode {
    const { data } = useSummaryCards();
    const totalAssetAndItemsCount = data?.assetsCount ?? 0;

    return (
        <Card
            title={
                <SummaryCardTitle
                    icon="stack"
                    title="Assets"
                    iconClassName={s.assetItemsIcon}
                />
            }
            cardClassName={s.card}
            foldable={false}
        >
            <SummaryCardContent
                footer={
                    <h2 className="text-white">{totalAssetAndItemsCount}</h2>
                }
                to={getProjectPath(ProjectPath.Assets, pid)}
            />
        </Card>
    );
}
